import { baseState, baseMutations } from '@/store/mixins'
import monthlyAllowance from '@/api/payroll/monthly-allowance'

export const state = {
    ...baseState,
    employeeProfiles: [],
    payrollItemAllowances: []
}
export const getters = {}
export const mutations = {
    ...baseMutations,
    SET_EMPLOYEE_PROFILES(state, employeeProfiles) {
        state.employeeProfiles = employeeProfiles
    },
    SET_PAYROLL_ITEM_ALLOWANCE(state, payrollItemAllowances) {
        state.payrollItemAllowances = payrollItemAllowances
    }
}
export const actions = {
    async getEmployeeProfile(context, attributes = {}) {
        let response = await monthlyAllowance.employeeProfile({
            params: attributes
        })
        context.commit('SET_EMPLOYEE_PROFILES', response.data)
    },
    async getPayrollItemAllowance(context, attributes = {}) {
        let response = await monthlyAllowance.payrollItemAllowance({
            params: attributes
        })
        context.commit('SET_PAYROLL_ITEM_ALLOWANCE', response.data)
    },
    store(context, data) {
        return monthlyAllowance.store(data)
    },
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        )
        return monthlyAllowance.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    update(context, { id, data }) {
        return monthlyAllowance.update(id, data)
    },
    destroy(context, id) {
        return monthlyAllowance.destroy(id)
    },
    formViewModel(context, payload) {
        return monthlyAllowance.formViewModel(payload)
    },
    exportExcel(context, data) {
        return monthlyAllowance.exportExcel(data)
    },
    importExcel(context, data) {
        return monthlyAllowance.importExcel(data)
    }
}
